module.exports = __webpack_public_path__ + "static/media/download_on_appstore.ab8ccebc.svg";